<script setup lang="ts">
const { linkToHelpCenter } = useLinks();
const { openSupportChat, hasLiveSupport } = useLiveSupport();
</script>

<template>
  <div :class="$style.menuItems">
    <NuxtLink
      v-if="linkToHelpCenter"
      active-class="opacity-100"
      :class="$style.menuItem"
      no-prefetch
      target="_blank"
      :to="linkToHelpCenter"
    >
      <NuxtIcon
        :class="$style.buttonIcon"
        name="external"
      />
      <span>{{ $t('sidebar.help_center') }}</span>
    </NuxtLink>

    <NuxtLink
      :class="$style.menuItem"
      :to="localeLink('/contact')"
    >
      <NuxtIcon
        :class="$style.buttonIcon"
        name="chat"
      />
      {{ $t('contact.title') }}
    </NuxtLink>

    <button
      v-if="hasLiveSupport"
      :class="$style.menuItem"
      @click="openSupportChat"
    >
      <NuxtIcon
        :class="$style.buttonIcon"
        name="messages"
      />
      {{ $t('sidebar.live_support') }}
    </button>
  </div>
</template>

<style module lang="scss">
.menuItems {
  @apply flex items-center justify-center pt-5 gap-2;

  .menuItem {
    @apply inline-flex items-center justify-start gap-2 py-2 px-3 text-sm font-bold text-texts/90 hover:opacity-100 bg-black/30 rounded-lg;

    &:hover {
      @apply bg-black/40;
    }

    .buttonIcon {
      @apply text-xl text-primary;
    }
  }
}
</style>
